import React, { FC } from 'react';
import styled from 'styled-components';
import { SettingsFormPageSkeleton } from '../settings/settingsSkeleton';

const CheckoutSkeletonContainer = styled.div`
    padding: 0 48px;
`;

export const UserCheckoutPageSkeleton: FC = () => (
    <CheckoutSkeletonContainer>
        <SettingsFormPageSkeleton />
    </CheckoutSkeletonContainer>
);
